import template from './password.html';
import controller from './password.controller';
import './password.styl';

const PasswordComponent = {
  template,
  controller,
  controllerAs: 'password',
  require: {
    app: '^^app'
  }
};

export default PasswordComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/auth/password/password.component.js
 **/